/**
 * Quick Add to Cart Fix - Smooth AJAX Implementation
 * Handles both grid/list view quick add and product page add to cart
 * No page reload, smooth animations, proper error handling
 */

(function($) {
  'use strict';

  // Shopify add to cart function with smooth AJAX
  window.Shopify = window.Shopify || {};
  
  /**
   * Add item from form (product page)
   * @param {string} formId - The ID of the add to cart form
   * @param {number} productId - The product ID
   */
  Shopify.addItemFromFormStart = function(formId, productId) {
    var $form = $('#' + formId);
    var $button = $form.find('button[type="submit"]');
    var $buttonText = $button.find('.cart-title');
    var originalText = $buttonText.text();
    
    // Show loading state
    $button.prop('disabled', true);
    $buttonText.html('<i class="sli sli-reload rotate-infinite"></i> Adding...');
    
    // Get form data
    var formData = $form.serialize();
    
    // AJAX add to cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: formData,
      dataType: 'json',
      success: function(item) {
        // Success feedback
        $buttonText.html('<i class="sli sli-check"></i> Added!');
        
        // Update cart count/drawer
        updateCart();
        
        // Open cart drawer if exists
        if ($('.shopping-cart-content').length) {
          setTimeout(function() {
            $('.shopping-cart-content').addClass('show');
            $('.cart-wrap').addClass('show');
          }, 300);
        }
        
        // Reset button after 2 seconds
        setTimeout(function() {
          $button.prop('disabled', false);
          $buttonText.text(originalText);
        }, 2000);
      },
      error: function(xhr) {
        // Error handling
        var errorMsg = 'Error adding to cart';
        try {
          var response = JSON.parse(xhr.responseText);
          errorMsg = response.message || response.description || errorMsg;
        } catch(e) {}
        
        $buttonText.html('<i class="sli sli-close"></i> ' + errorMsg);
        
        // Reset button after 3 seconds
        setTimeout(function() {
          $button.prop('disabled', false);
          $buttonText.text(originalText);
        }, 3000);
      }
    });
  };
  
  /**
   * Quick add to cart from grid/list (collection page)
   * @param {number} variantId - The variant ID to add
   * @param {number} qty - Quantity to add (default: 1)
   */
  window.quickAddToCart = function(variantId, qty) {
    qty = qty || 1;
    
    // Find the button that was clicked
    var $clickedButton = $('.ajax-spin-cart-drawer[data-loading="true"]').last();
    if (!$clickedButton.length) {
      $clickedButton = $('.ajax-spin-cart-drawer, .ajax-spin-cart, .theme-product-action-btn').filter(function() {
        return $(this).data('variant-id') == variantId || 
               $(this).closest('[data-product-id]').length;
      }).first();
    }
    
    // Show loading state
    $clickedButton.addClass('loading');
    
    // AJAX add to cart
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        id: variantId,
        quantity: qty
      },
      dataType: 'json',
      success: function(item) {
        // Success feedback
        $clickedButton.removeClass('loading').addClass('added');
        
        // Update cart
        updateCart();
        
        // Open cart drawer
        if ($('.shopping-cart-content').length) {
          setTimeout(function() {
            $('.shopping-cart-content').addClass('show');
            $('.cart-wrap').addClass('show');
          }, 300);
        }
        
        // Reset button state after 2 seconds
        setTimeout(function() {
          $clickedButton.removeClass('added');
        }, 2000);
      },
      error: function(xhr) {
        // Error handling
        $clickedButton.removeClass('loading').addClass('error');
        
        var errorMsg = 'Error';
        try {
          var response = JSON.parse(xhr.responseText);
          errorMsg = response.message || response.description || errorMsg;
        } catch(e) {}
        
        // Show error tooltip
        var $tooltip = $('<div class="quick-add-error-tooltip">' + errorMsg + '</div>');
        $clickedButton.after($tooltip);
        $tooltip.fadeIn(200);
        
        // Remove error state and tooltip after 3 seconds
        setTimeout(function() {
          $clickedButton.removeClass('error');
          $tooltip.fadeOut(200, function() {
            $(this).remove();
          });
        }, 3000);
      }
    });
  };
  
  /**
   * Update cart count and drawer content
   */
  function updateCart() {
    // Get cart JSON
    $.getJSON('/cart.js', function(cart) {
      // Update cart count
      $('.cart-count, .cart-items-count, .icon-cart span').text(cart.item_count);
      
      // Update cart drawer if it exists
      if ($('.shopping-cart-content').length) {
        $.get('/cart?view=ajax', function(html) {
          var $html = $(html);
          var $cartContent = $html.find('.ajax-cart-content');
          if ($cartContent.length) {
            $('.shopping-cart-content').html($cartContent.html());
          }
        });
      }
    });
  }
  
  /**
   * Handle click events for quick add buttons
   */
  $(document).ready(function() {
    
    // Grid/List quick add to cart
    $(document).on('click', '.ajax-spin-cart-drawer:not(.loading)', function(e) {
      e.preventDefault();
      
      var $this = $(this);
      var $product = $this.closest('.product-wrapper, .theme-product, .product-item, .product-grid-item');
      
      // Mark button as loading to prevent double clicks
      $this.attr('data-loading', 'true');
      
      // Try to get variant ID from various sources
      var variantId = $this.data('variant-id') || 
                     $this.attr('onclick')?.match(/\d+/)?.[0] ||
                     $product.find('select[name="id"] option:selected').val() ||
                     $product.find('input[name="id"]').val() ||
                     $product.data('product-id');
      
      if (variantId) {
        quickAddToCart(variantId, 1);
      }
      
      // Remove loading attribute after a short delay
      setTimeout(function() {
        $this.removeAttr('data-loading');
      }, 500);
    });
    
    // Also handle ajax-spin-cart class
    $(document).on('click', '.ajax-spin-cart:not(.loading)', function(e) {
      e.preventDefault();
      
      var $this = $(this);
      var $product = $this.closest('.product-wrapper, .theme-product, .product-item, .product-grid-item');
      
      $this.attr('data-loading', 'true');
      
      var variantId = $this.data('variant-id') || 
                     $this.attr('onclick')?.match(/\d+/)?.[0] ||
                     $product.find('select[name="id"] option:selected').val() ||
                     $product.find('input[name="id"]').val();
      
      if (variantId) {
        quickAddToCart(variantId, 1);
      }
      
      setTimeout(function() {
        $this.removeAttr('data-loading');
      }, 500);
    });
    
    // Theme product action buttons
    $(document).on('click', '.theme-product-action-btn:not(.loading)', function(e) {
      e.preventDefault();
      
      var $this = $(this);
      var $product = $this.closest('.product-wrapper, .theme-product, .product-item, .product-grid-item');
      
      $this.attr('data-loading', 'true');
      
      var variantId = $this.data('variant-id') || 
                     $this.attr('onclick')?.match(/\d+/)?.[0] ||
                     $product.find('select[name="id"] option:selected').val() ||
                     $product.find('input[name="id"]').val();
      
      if (variantId) {
        quickAddToCart(variantId, 1);
      }
      
      setTimeout(function() {
        $this.removeAttr('data-loading');
      }, 500);
    });
  });
  
})(jQuery);